<div class="legal-page">
  <div class="legal-container">
    <div class="legal-header">
      <h1>{{ 'cookiePolicy.title' | translate }}</h1>
      <p class="last-updated">{{ 'legal.lastUpdated' | translate }}: {{ lastUpdated }}</p>
    </div>

    <div class="legal-content">
      <h2>{{ 'cookiePolicy.section1.title' | translate }}</h2>
      <p>{{ 'cookiePolicy.section1.content' | translate }}</p>

      <div class="highlight-box">
        <p>
          <strong>{{ 'cookiePolicy.section1.choiceLabel' | translate }}:</strong> {{ 'cookiePolicy.section1.choiceText' | translate }}
        </p>
      </div>

      <h2>{{ 'cookiePolicy.section2.title' | translate }}</h2>
      <p>{{ 'cookiePolicy.section2.intro' | translate }}</p>

      <h3>{{ 'cookiePolicy.section2.essential.title' | translate }}</h3>
      <p>{{ 'cookiePolicy.section2.essential.content' | translate }}</p>
      <ul>
        <li><strong>{{ 'cookiePolicy.section2.essential.auth' | translate }}:</strong> {{ 'cookiePolicy.section2.essential.authDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section2.essential.security' | translate }}:</strong> {{ 'cookiePolicy.section2.essential.securityDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section2.essential.session' | translate }}:</strong> {{ 'cookiePolicy.section2.essential.sessionDesc' | translate }}</li>
      </ul>

      <h3>{{ 'cookiePolicy.section2.functional.title' | translate }}</h3>
      <p>{{ 'cookiePolicy.section2.functional.content' | translate }}</p>
      <ul>
        <li><strong>{{ 'cookiePolicy.section2.functional.language' | translate }}:</strong> {{ 'cookiePolicy.section2.functional.languageDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section2.functional.preferences' | translate }}:</strong> {{ 'cookiePolicy.section2.functional.preferencesDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section2.functional.formData' | translate }}:</strong> {{ 'cookiePolicy.section2.functional.formDataDesc' | translate }}</li>
      </ul>

      <h3>{{ 'cookiePolicy.section2.analytics.title' | translate }}</h3>
      <p>{{ 'cookiePolicy.section2.analytics.content' | translate }}</p>
      <ul>
        <li><strong>{{ 'cookiePolicy.section2.analytics.usage' | translate }}:</strong> {{ 'cookiePolicy.section2.analytics.usageDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section2.analytics.performance' | translate }}:</strong> {{ 'cookiePolicy.section2.analytics.performanceDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section2.analytics.features' | translate }}:</strong> {{ 'cookiePolicy.section2.analytics.featuresDesc' | translate }}</li>
      </ul>

      <h3>{{ 'cookiePolicy.section2.marketing.title' | translate }}</h3>
      <p>{{ 'cookiePolicy.section2.marketing.content' | translate }}</p>
      <ul>
        <li><strong>{{ 'cookiePolicy.section2.marketing.targeted' | translate }}:</strong> {{ 'cookiePolicy.section2.marketing.targetedDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section2.marketing.campaign' | translate }}:</strong> {{ 'cookiePolicy.section2.marketing.campaignDesc' | translate }}</li>
      </ul>

      <h2>{{ 'cookiePolicy.section3.title' | translate }}</h2>
      <table style="width: 100%; border-collapse: collapse; margin: 20px 0;">
        <thead>
          <tr style="background: #f8fafc;">
            <th style="padding: 12px; text-align: left; border-bottom: 2px solid #e5e7eb;">{{ 'cookiePolicy.section3.columnName' | translate }}</th>
            <th style="padding: 12px; text-align: left; border-bottom: 2px solid #e5e7eb;">{{ 'cookiePolicy.section3.columnPurpose' | translate }}</th>
            <th style="padding: 12px; text-align: left; border-bottom: 2px solid #e5e7eb;">{{ 'cookiePolicy.section3.columnDuration' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">horseloop_cookie_consent</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.consentPurpose' | translate }}</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.oneYear' | translate }}</td>
          </tr>
          <tr>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">horseloop_session</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.sessionPurpose' | translate }}</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.session' | translate }}</td>
          </tr>
          <tr>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">horseloop_auth</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.authPurpose' | translate }}</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.sevenDays' | translate }}</td>
          </tr>
          <tr>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">horseloop_preferences</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.preferencesPurpose' | translate }}</td>
            <td style="padding: 12px; border-bottom: 1px solid #e5e7eb;">{{ 'cookiePolicy.section3.oneYear' | translate }}</td>
          </tr>
        </tbody>
      </table>

      <h2>{{ 'cookiePolicy.section4.title' | translate }}</h2>
      <p>{{ 'cookiePolicy.section4.intro' | translate }}</p>
      <ul>
        <li><strong>{{ 'cookiePolicy.section4.googleAnalytics' | translate }}:</strong> {{ 'cookiePolicy.section4.googleAnalyticsDesc' | translate }}</li>
        <li><strong>{{ 'cookiePolicy.section4.paymentProviders' | translate }}:</strong> {{ 'cookiePolicy.section4.paymentProvidersDesc' | translate }}</li>
      </ul>

      <h2>{{ 'cookiePolicy.section5.title' | translate }}</h2>
      <p>{{ 'cookiePolicy.section5.intro' | translate }}</p>

      <h3>{{ 'cookiePolicy.section5.browserSettings.title' | translate }}</h3>
      <p>{{ 'cookiePolicy.section5.browserSettings.content' | translate }}</p>
      <ul>
        <li><strong>Chrome:</strong> {{ 'cookiePolicy.section5.browserSettings.chrome' | translate }}</li>
        <li><strong>Firefox:</strong> {{ 'cookiePolicy.section5.browserSettings.firefox' | translate }}</li>
        <li><strong>Safari:</strong> {{ 'cookiePolicy.section5.browserSettings.safari' | translate }}</li>
        <li><strong>Edge:</strong> {{ 'cookiePolicy.section5.browserSettings.edge' | translate }}</li>
      </ul>

      <h3>{{ 'cookiePolicy.section5.ourTool.title' | translate }}</h3>
      <p>{{ 'cookiePolicy.section5.ourTool.content' | translate }}</p>

      <h2>{{ 'cookiePolicy.section6.title' | translate }}</h2>
      <p>{{ 'cookiePolicy.section6.intro' | translate }}</p>
      <ul>
        <li>{{ 'cookiePolicy.section6.item1' | translate }}</li>
        <li>{{ 'cookiePolicy.section6.item2' | translate }}</li>
        <li>{{ 'cookiePolicy.section6.item3' | translate }}</li>
      </ul>

      <h2>{{ 'cookiePolicy.section7.title' | translate }}</h2>
      <p>{{ 'cookiePolicy.section7.content' | translate }}</p>

      <div class="contact-info">
        <h3>{{ 'legal.contactUs' | translate }}</h3>
        <p>{{ 'cookiePolicy.contactIntro' | translate }}</p>
        <p>
          <strong>{{ 'legal.email' | translate }}:</strong> privacy&#64;horseloop.com<br>
          <strong>{{ 'legal.address' | translate }}:</strong> HorseLoop AS, Oslo, Norway
        </p>
      </div>
    </div>
  </div>
</div>
